import {
  Accordion,
  AccordionItem,
  Box,
  Heading,
  Stack,
  Text,
  TextLink,
} from 'braid-design-system';
import type { ReactNode } from 'react';

export interface FAQ {
  question: string;
  answer: ReactNode;
  link?: {
    label: string;
    href: string;
  };
}

interface FaqProp {
  faqs: FAQ[];
}

const FaqAnswer = ({ faq }: { faq: FAQ }) => (
  <Stack space="medium">
    <Text>{faq.answer}</Text>
    {faq.link ? (
      <Text>
        <TextLink href={faq.link.href}>{faq.link.label}</TextLink>
      </Text>
    ) : null}
  </Stack>
);

export const FaqAccordion = ({ faqs }: FaqProp) => (
  <Box data={{ testid: 'faq-accordion' }}>
    <Stack space="large">
      <Stack space="small">
        <Heading level="2" align="center">
          Frequently asked selling questions
        </Heading>
        <Text align="center">
          Find answers to common questions about selling your business on SEEK
          Business.
        </Text>
      </Stack>

      <Accordion space="medium">
        {faqs.map((faq, index) => (
          <AccordionItem label={faq.question} key={index} id={`faq-${index}`}>
            <FaqAnswer faq={faq} />
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  </Box>
);
